import Content from "../../Components/Content/Content";
import LicenseOverviewTable from "../../Components/LicenseOverviewTable/LicenseOverviewTable";

const AllLicenses: React.FC = () => {
    return (
        <>
            <Content>
                <div className={"row p-0 m-0"}>
                    <div className={"col-12 p-0"}>
                        <LicenseOverviewTable />                        
                    </div>
                </div>
            </Content>
        </>
    )
};

export default AllLicenses;